// eslint-disable-next-line
export const SET_USER_PREFERENCES = 'userPreferences/set-user-preferences';
